import './app.scss';
import './rte.scss';

import './js/jquery-import';

import './js/behaviour/to-top-button';
import './js/behaviour/lightbox';
import './js/behaviour/video';
import './js/behaviour/header';
import './js/behaviour/aos';

import './js/navigation/main-navigation';
import './js/navigation/main-navigation-mobile';

import './js/ce/image';
import './js/ce/timeline';
import './js/ce/standorte';
import './js/ce/testimonials';
import './js/ce/counter';
import './js/ce/before-after';
import './js/ce/image-map';
import './js/ce/filter-container';

import './js/news/list';
import './js/news/detail';
import './js/news/archive';

